import {Component, OnInit} from '@angular/core';
import {AuthService} from '../../../../../firebase/src/lib/services/auth.service';

@Component({
    selector: 'app-progress',
    templateUrl: './progress.component.html',
    styleUrls: ['./progress.component.scss']
})
export class ProgressComponent implements OnInit {
    slides = [];
    currentStepIndex = 0;
    currentStepProgress = 0;
    photoURL = null;

    progress = null;

    constructor(
        public auth: AuthService,
    ) {

    }

    ngOnInit(): void {

        this.auth.$userSessions.subscribe((res: any) => {
            if (res) {
                const {stepIndex, stepProgress} = this.currentLevel(45);
                this.currentStepIndex = stepIndex + 1;
                this.currentStepProgress = stepProgress - 1;
            }
        });
        this.photoURL = this.auth.userData.photoURL;
    }

    currentLevel(progress: number): any {
        return {
            stepIndex: progress - 7 > 0
                ? Math.ceil( (progress - 7)  / 14)
                : 0,
            stepProgress: progress - 7 > 0
                ? (progress - 7) % 14 || 14
                : progress,
        };
    }
}
